export default __webpack_public_path__ + "static/CP-card-01-9c8f1c0d238cb48d2dc24aea8c8e186b.svg";